if (!customElements.get('promotion-tabs')) {
  class PromotionTabs extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector('.--promotion-tab');
      this.tabItems = [];
      this.promotionTargets = Array.from(document.querySelectorAll('[data-promotion-id]'));
      this.init();
    }

    init() {
      if (!this.tabList || this.promotionTargets.length === 0) return;

      this.tabList.innerHTML = '';

      const promotionLists = {
        promotion_id_1: 'Introduction',
        promotion_id_2: 'Shop All',
        promotion_id_3: 'Perfect Match',
        promotion_id_4: 'FAQ'
      };

      this.promotionTargets.forEach((target, index) => {
        const promotionId = target.dataset.promotionId || target.getAttribute('data-promotion-id');
        if (!promotionId) return;

        const tabItem = document.createElement('button');
        tabItem.type = 'button';
        tabItem.className = '--promotion-tab-item h8';
        tabItem.dataset.promotionId = promotionId;
        tabItem.dataset.tabIndex = index;
        tabItem.textContent = promotionLists[promotionId] || "";
        tabItem.addEventListener('click', this.handleTabClick.bind(this));

        this.tabList.appendChild(tabItem);
        this.tabItems.push(tabItem);
      });

      if (this.tabItems.length > 0) {
        this.tabItems[0].classList.add('--promotion-is-active');
      }

      this.setupScrollObserver();
    }

    setupScrollObserver() {
      const offset = window.matchMedia('(max-width: 768px)').matches ? 159 : 176;
      const rootMargin = `-${offset}px 0px -70% 0px`;

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const promotionId = entry.target.dataset.promotionId;
          if (!promotionId) return;

          this.tabItems.forEach((item) => {
            item.classList.toggle('--promotion-is-active', item.dataset.promotionId === promotionId);
          });
        });
      }, { rootMargin, threshold: 0 });

      this.promotionTargets.forEach((target) => this.observer.observe(target));
    }

    handleTabClick(event) {
      const clickedItem = event.currentTarget;
      const promotionId = clickedItem.dataset.promotionId;
      const target = this.promotionTargets.find((element) => element.dataset.promotionId === promotionId);

      if (!target) return;

      this.tabItems.forEach((item) => {
        item.classList.remove('--promotion-is-active');
      });

      clickedItem.classList.add('--promotion-is-active');
      const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
      const offset = window.matchMedia('(max-width: 768px)').matches ? 159 : 176;
      window.scrollTo({
        top: targetTop - offset,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('promotion-tabs', PromotionTabs);
}